import { Component, Injector, OnInit } from '@angular/core';
import { environment } from '@uw-env/environment';
import { BaseComponent } from '@uw/core/base.component';
import { PostLoginDestinationPage } from '@uw/core/enums/post-login-destination-page.enum';
import { AuthService } from '@uw/core/services/auth.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { Subject, combineLatest, switchMap, takeUntil } from 'rxjs';
import { AuthResponse } from '../models/auth-response';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';

@Component({
    template: '', host: { 'data-component': 'post-login-navigation' },
    standalone: false
})
export class PostLoginNavigationComponent
  extends BaseComponent
  implements OnInit
{
  donorLoginSuccess$ = new Subject<void>();

  constructor(
    protected authService: AuthService,
    protected campaignService: CampaignService,
    protected customNavigationService: CustomNavigationService,
    injector?: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.donorLoginSuccess$
      .pipe(
        switchMap(_ => combineLatest([this.campaignService.getDonorActiveCampaignList(), this.campaignService.getLatestClosedCampaignGuid()])),
        takeUntil(this.destroy$)
      )
      .subscribe(
        ([campaignList, latestClosedCampaignGuid]) => {
          if (campaignList && campaignList.length > 0) {
            this.customNavigationService.navigate(['/main/campaign/select-campaign']);
          } else if (latestClosedCampaignGuid) { // redirect the user to latest closed campaign page in case there are no active campaigns
            this.customNavigationService.navigate(['/donor', latestClosedCampaignGuid, 'closed-campaign']);
          } else {
            this.customNavigationService.navigate(['/donor-info']);
          }
        },
        (_err) => {
          this.showError(this.translateService.instant('login.failed_msg'));
        }
      );
  }

  navigateToPostLoginLoginDestinationPage(authResponse: AuthResponse): void {
    const destinationPage =
      this.authService.getPostLoginDestinationPage(authResponse);

    if (destinationPage == PostLoginDestinationPage.MFA_PAGE) {
      localStorage.setItem('mfaToken', authResponse.mfaToken);
      // proceed to mfa page if mfa is required
      this.customNavigationService.navigate(['mfa'], {
        state: { mfaToken: authResponse.mfaToken },
      });
    } else if (destinationPage == PostLoginDestinationPage.PASSWORD_EXPIRED_PAGE) {
      // proceed to change password page if the logged in user's password is expired.
      this.customNavigationService.navigate(['password-expired'], {
        state: { passwordResetToken: authResponse.passwordResetToken },
      });
    } else if (destinationPage == PostLoginDestinationPage.APP_SELECTION_PAGE) {
      // proceed to app-selection page if the logged in user has both donor role and admin roles
      this.customNavigationService.navigate(['app-selection'], {
        state: { token: authResponse.token },
      });
    } else if (destinationPage == PostLoginDestinationPage.DONATION_SITE) {
      // proceed to donation site if the logged in user has only donor role
      this.donorLoginSuccess$.next();
    } else if (destinationPage == PostLoginDestinationPage.ADMIN_SITE) {
      // proceed to admin site if the logged in user has only admin role

      let adminUrl = environment.adminSiteURL;

      // if (authResponse.token) {
      //   adminUrl +='?access=' + authResponse.token + '&lang=' + localStorage.getItem('lang');
      // }
      adminUrl +='?access=switch&lang=' + localStorage.getItem('lang');
      window.location.href = adminUrl;
    }
  }
}
